export const name = 'nameConventionDialog';
export default function nameConventionDialog($scope, $log, chipsService, $mdDialog, errorDialogOpen) {
    //noinspection BadExpressionStatementJS
    'ngInject';

    let vm = this;
    vm.close = close;
    vm.apply = apply;
    vm.validateChip = validateChip;
    vm.transformChip = transformChip;
    vm.customText = '';
    vm.selectedPlaceholdersObjects  = [];
    vm.placeholdersToSelectFromObjects = [];
    vm.onChooseFromPlaceholdersClick = onChooseFromPlaceholdersClick;
    vm.maxCustomTextLength = 20;
    vm.isPlaceholderInputInvalid = false;
    vm.placeholdersToSelectFrom = ['TEMPLATE_NAME', 'DATABASE_NAME', 'RANGE', 'ASSETS_FOLDER', 'DATE_TIME'];

    (function initialize(){
      if(vm.selectedNameConvention && vm.selectedNameConvention.length > 0){
        let placeHolderRegex = /<[a-zA-Z_]*>/g;
        if(placeHolderRegex.test(vm.selectedNameConvention)) {
          vm.selectedNameConvention.match(placeHolderRegex).forEach((match) => {
            let matchStr = match.substring(1, match.length - 1);
            let lastIndexOfCurrentMatch = vm.selectedNameConvention.lastIndexOf(match);
            if (lastIndexOfCurrentMatch > 0) {
              let startIndex = 0;
              if (vm.selectedNameConvention.startsWith('_')) {
                startIndex = 1;
              }
              let customPlaceHolder = vm.selectedNameConvention.substring(startIndex, lastIndexOfCurrentMatch);
              if (customPlaceHolder.endsWith('_')) {
                customPlaceHolder = customPlaceHolder.substring(0, customPlaceHolder.length - 1);
              }
              if(customPlaceHolder) {
                vm.selectedPlaceholdersObjects.push({
                  name: customPlaceHolder,
                  type: 'custom',
                  lowCaseName: angular.lowercase(customPlaceHolder)
                });
              }
            }

            if (vm.placeholdersToSelectFrom.includes(matchStr.toUpperCase())) {
              vm.selectedPlaceholdersObjects.push({
                name: matchStr,
                type: 'existed',
                lowCaseName: angular.lowercase(matchStr)
              });
            }

            vm.selectedNameConvention = vm.selectedNameConvention.substring(lastIndexOfCurrentMatch + match.length, vm.selectedNameConvention.length);
          });
          if(vm.selectedNameConvention.length > 1){
            let lastCustomPlaceholder = vm.selectedNameConvention.substring(1, vm.selectedNameConvention.length);
            vm.selectedPlaceholdersObjects.push({name:lastCustomPlaceholder, type:'custom', lowCaseName:angular.lowercase(lastCustomPlaceholder)});
          }
        }else{
          let placeholders = vm.selectedNameConvention.split('_');
          placeholders.forEach(placeholder => {
            vm.selectedPlaceholdersObjects.push({name:placeholder, type:'custom', lowCaseName:angular.lowercase(placeholder)});
          });
        }

        let selectedPlaceholdersNames = vm.selectedPlaceholdersObjects.map(placeholder => placeholder.name);
        vm.placeholdersToSelectFrom.forEach(element => {
          if(selectedPlaceholdersNames.includes(element) === false) {
            vm.placeholdersToSelectFromObjects.push({
              name: element,
              type: 'existed',
              lowCaseName: angular.lowercase(element)
            });
          }
        });
      }else{
        vm.placeholdersToSelectFrom.forEach(element => {
          vm.placeholdersToSelectFromObjects.push({
            name: element,
            type: 'existed',
            lowCaseName: angular.lowercase(element)
          });
        });
      }
    }());

    function validateChip($chip){
      if(/\$|\*|\%|\^|\+|\#|\&/g.test($chip)){
        vm.isPlaceholderInputInvalid = true;
      }else{
        vm.selectedPlaceholdersObjects.pop();
        vm.isPlaceholderInputInvalid = false;
      }
    }

    function onChooseFromPlaceholdersClick(placeholder, $index){
        // remove from selected from and add to selected
        vm.selectedPlaceholdersObjects.push(placeholder);
        vm.placeholdersToSelectFromObjects.splice($index,1);
    }

    function close(){
        $mdDialog.hide();
    }

    function apply(){
        let placeholders = vm.selectedPlaceholdersObjects.map(chip => {
          if(vm.placeholdersToSelectFrom.includes(chip.name)){
            return '<' + chip.name + '>';
          }else{
            return chip.name;
          }
        });
        $mdDialog.hide(placeholders.join('_'));
    }

  function transformChip(chip) {
    // If it is an object, it's already a known chip
    if (angular.isObject(chip)) {
      // remove the chip from the select from collection
      for(let iChip=0; iChip < vm.chipsToSelectFromObjects.length; iChip++){
        if(vm.chipsToSelectFromObjects[iChip].name === chip.name){
          vm.chipsToSelectFromObjects.splice(iChip,1);
          break;
        }
      }
      return chip;
    }else {
      chip = chip.replace(/\$|\*|\%|\^|\+|\#|\&/g,'');
      let newChipText = angular.lowercase(chip);
      if(newChipText === ''){
        return null;
      }
      // check if already contain this chip as selected and if so - return it
      for (let iChip = 0; iChip < vm.selectedPlaceholdersObjects.length; iChip++) {
        if (vm.selectedPlaceholdersObjects[iChip].lowCaseName === newChipText) {
          return vm.selectedPlaceholdersObjects[iChip];
        }
      }

      // Otherwise, create a new one
      return {name: chip, type: 'custom', lowCaseName: angular.lowercase(chip)};
    }
  }

  $scope.$watchCollection('vm.selectedPlaceholdersObjects',function(newVal,oldVal){
    // find if chip removed by looking at what is missing at the newVal - run over the old, try to locate it at the new - if it is not in there then there is a chip removed - add it to the chips to choose from
    let addedChips = [];
    for(let iOld=0; iOld < oldVal.length; iOld++){
      let isCheepLocated = false;
      for(let iNew=0; iNew < newVal.length; iNew++){
        if(newVal[iNew].lowCaseName === oldVal[iOld].lowCaseName){
          isCheepLocated = true;
          break;
        }
      }
      if(isCheepLocated === false){
        addedChips.push(oldVal[iOld]);
      }
    }

    if(addedChips.length > 0){
      addedChips.forEach(function(chip){
        if(chip.type === 'existed'){
          vm.placeholdersToSelectFromObjects.push(chip);
        }
      });
    }

    // find if the chip was added - by looking at the newVal comparing to the old. if added - look if it is in the list of to choose from and if so - remove it from there.
    // nothing to do here - it is already done by transformChip.
  });
}
